<template>
  <el-dialog
    class="dialog-item"
    :visible="_visible"
    :title="title"
    center
    :width="width"
    lock-scroll
    :close-on-click-modal="false"
    @close="close"
  >
    <slot />
    <span slot="footer" class="dialog-footer">
      <el-button
        v-if="button.left"
        class="btn cancel-btn"
        @click="cancel"
      >{{ button.left }}</el-button>
      <el-button
        v-if="button.right"
        type="primary"
        :loading="loading"
        :disabled="buttonDisabledRight"
        class="btn comfirm-btn"
        @click="comfirm"
      >{{ button.right }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ContentDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '这是标题'
    },
    width: {
      type: String,
      default: '360px'
    },
    button: {
      type: Object,
      default: function() {
        return {
          left: this.$t('components.common.cancel'), // '取消', // 不传则不显示该按钮，通过按钮文案是否传参，控制单双按钮显示
          right: this.$t('components.common.confirm') // '确认'
        }
      }
    },
    buttonDisabledLeft: {
      type: Boolean,
      default: false
    },
    buttonDisabledRight: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    _visible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('close', val)
      }
    }
  },
  created() {},
  mounted() {},

  methods: {
    close() {
      this._visible = false
    },
    cancel() {
      this._visible = false
    },
    comfirm() {
      this.$emit('confirm')
    }
  }
}
</script>
<style lang='scss' scoped>
::v-deep.dialog-item {
	.el-dialog__header{
		padding: 20px;
	}
	.el-dialog__body {
		padding: 8px 0;
		background-color: #f5f7fa;
	}
	.el-dialog__footer {
		height: 64px;
		padding: 16px 0px;
		text-align: center;
	}
	.dialog-footer {
		padding: 0 32px;
		display: flex;
	}

	.btn {
		flex: 1;
		height: 32px;
		border-radius: 18px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}

	.comfirm-btn {
		background: #1fa0e8;
	}
	.el-button.is-disabled {
		background: #ccc;
		border-color: #ccc;
	}
	.el-button {
		padding: 0;
	}
}
</style>
